var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('label',{staticClass:"vform-editor-label section"},[_vm._v("Height")]),_c('label',{staticClass:"section ml-4 vform-editor-body slider-label"},[_vm._v(_vm._s(this.height)+"px")]),_c('slider',{attrs:{"default-value":20,"initial-value":_vm.height,"interval":10,"max":100,"min":0},on:{"change":function (val) { this$1.$set(this$1, 'height', val) }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }